import type { MultipleActions, QuickAction } from "./types";

export function getQuickActions(actions: MultipleActions[]): QuickAction[] {
    return actions.flatMap(({ value, ...rest }: MultipleActions) =>
        Array.isArray(value) ? value.map((v) => ({ ...rest, value: v })) : { ...rest, value },
    );
}
